import Immutable from 'immutable';

export default {
  getDependencies() {},

  getDependenciesCompleted(body, params, data, query, response, actionParams) {
    // get editing catalog
    const { catalogId, fieldId } = params;
    this.setDependecies(catalogId, fieldId, body);
  },

  getDependenciesFailed(body, params, data, query, response, actionParams) {
    // get editing catalog
    const { catalogId, fieldId } = params;
    this.setDependecies(catalogId, fieldId, null);
  },

  setDependecies(catalogId, fieldId, data) {
    // get editing catalog
    const catalog = this.getIn(['catalogs', catalogId]);
    const sectionId = catalog && catalog.get('sectionId');
    const catalogKey = ['editingCatalogs', sectionId];
    const editingCatalog = this.getIn(catalogKey);
    if (!editingCatalog) {
      return;
    }

    // create dependecy list if not set
    if (!editingCatalog.get('dependencies')) {
      this.setIn([...catalogKey, 'dependencies'], Immutable.Map());
    }

    // set data
    if (fieldId) {
      this.setIn([...catalogKey, 'dependencies', fieldId], Immutable.fromJS(data || []));
    } else {
      this.setIn([...catalogKey, 'dependencies'], Immutable.fromJS(data || []));
    }
    this.changed();
  },
};
